<template>
    <div>

        <v-toolbar dense app color="primary" flat dark>
            <v-toolbar-side-icon @click.stop="drawer()"/>
            <v-toolbar-title>Caixas CTO</v-toolbar-title>
            <v-spacer/>
            <v-btn icon @click.stop="search = !search" v-if="ctos && ctos.length">
                <v-icon>search</v-icon>
            </v-btn>
        </v-toolbar>

        <v-container fluid v-if="search">
            <v-flex xs12  transition="fade-transition">
                <v-text-field
                        type="number"
                    label="Número de Caixa"
                    v-model.number="search_text"
                    counter
                    max="15"
                />
            </v-flex>
        </v-container>

        <v-list two-line subheader v-if="ctos && ctos.length" style="margin-top: 10px">
            <template v-for="item in getCaixas" >
                <div :key="item._id">
                    <v-list-tile  avatar @click="goTo(item._id)">

                        <v-list-tile-avatar>
                            <v-icon :class="[iconClass]">filter_tilt_shift</v-icon>
                        </v-list-tile-avatar>

                        <v-list-tile-content>

                            <v-list-tile-sub-title>
                                <b>{{ item.nome }}</b>
                            </v-list-tile-sub-title>

                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-btn icon ripple>
                                <v-icon color="grey lighten-1">keyboard_arrow_right</v-icon>
                            </v-btn>
                        </v-list-tile-action>

                    </v-list-tile>
                    <v-divider></v-divider>
                </div>
            </template>

        </v-list>

        <v-container fluid  v-if="!ctos || ! ctos.length">
            <v-alert outline color="success" icon="thumb_up" :value="true">
                Nenhuma Caixa Encontrada
            </v-alert>
        </v-container>

    </div>
</template>

<script>
    import { EventBus } from "../../utils/event-bus.js";
    import { Caixas } from "../../class/caixas";
    import { date } from "../../filters";

    export default {
        name: "list-ctos",
        data () {
            return {
                ctos: [],
                search_text: null,
                iconClass: "blue white--text",
                search: false
            };
        },
        filters: {
            date
        },
        computed: {
            getCaixas: function () {
                if (!this.search_text) {
                    return this.ctos;
                }

                return this.ctos.filter((player) => {
                    return player.numero === this.search_text;
                });
            }
        },
        async beforeMount () {
            this.load();
        },
        methods: {
            load () {
                Caixas
                    .ctos()
                    .then((ordens) => { this.ctos = ordens.data; })
                    .catch((err) => console.error(err));
            },
            drawer: () => {
                EventBus.$emit("drawer", true);
            },
            goTo: function (id) {
                this.$router.push("/caixa/cto/" + id);
            }
        }
    };
</script>

<style scoped>

</style>
